export default __webpack_public_path__ + "static/media/Flag_of_Lithuania.170086e9.svg";